import { modelRequest } from "@stem-sims/nexus"
import { OrgInvitePostPrams } from "../types/organizationTypes"

/**
 * Invites users to organization
 */
export function post(parms: OrgInvitePostPrams): Promise<{ message: string }> {
    return modelRequest.post('/api/organizations/invite', parms)
}
